export const UPSERT_PARTNER_ATTRIBUTES_CONSTANT = {
  name: {
    type: 'text',
    key: 'name',
    label: 'Name',
  },
  website: {
    type: 'text',
    key: 'website',
    label: 'Website',
  },
  email: {
    type: 'email',
    key: 'email',
    label: 'Email',
  },
  mode: {
    type: 'select',
    key: 'mode',
    label: 'Mode',
  },
  address1: {
    type: 'text',
    key: 'address1',
    label: 'Address 1',
  },
  address2: {
    type: 'text',
    key: 'address2',
    label: 'Address 2',
  },
  city: {
    type: 'text',
    key: 'city',
    label: 'City',
  },
  zip: {
    type: 'text',
    key: 'zip',
    label: 'Postal Code',
  },
  country: {
    type: 'select',
    key: 'country',
    label: 'Country',
  },
  phone: {
    type: 'tel',
    key: 'phone',
    label: 'Phone',
  },
  logo: {
    type: 'file',
    key: 'logo',
    label: 'Logo',
  },
} as const;

export const MODE = [
  {
    name: 'Online',
    value: 'ONLINE',
  },
  {
    name: 'Manual',
    value: 'MANUAL',
  },
];
